/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { newInstantMessage } from '../+state/intercom.actions';
import { InstantMessage } from 'CalltakingCoreApi';
import { IntercomChat } from '../model/intercom-chat';
import { ClusterUrlProviderService } from '../../core/services/cluster-url-provider.service';
import { StompBaseConsumer } from '../../core/abstract/stomp-base-consumer';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
    providedIn: 'root'
})
export class IntercomService extends StompBaseConsumer {
    private readonly API_BASE_URL = '/api/imc/v1/';

    constructor(
        private http: HttpClient,
        protected store: Store,
        private clusterUrlProviderService: ClusterUrlProviderService,
        protected stompManager: StompManagerService
    ) {
        super(stompManager, store);
    }


    protected getTopics(): Topic[] {
        return [Topic.IM_MESSAGE_NEW];
    }

    protected handleNewInstantMessage(message: InstantMessage): void {
        this.store.dispatch(newInstantMessage({ message: message }));
    }

    protected getTopicHandlers(): { [p in Topic]?: (message: any) => void } {
        return {
            [Topic.IM_MESSAGE_NEW]: this.handleNewInstantMessage.bind(this),
        };
    }

    handleSubscriptionInit(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Instant Message topic ${topic} subscription success: ${receiptId}`);
    }

    handleSubscriptionEnd(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Instant Message ${topic} subscription end: ${receiptId}`);
    }

    handleStompError(topic: string, receiptId: string, error: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Message topic ${topic} subscription failed=${error} for receiptId=${receiptId}`);
    }

    public instantMessage(chat: IntercomChat, message: string, clusterName: string) {
        let im: Partial<InstantMessage> = {
            chatId: chat.id,
            chatParticipants: chat.intercomParticipants,
            message: message
        };

        const url = this.clusterUrlProviderService.getClusterSpecificUrl(clusterName, `${this.API_BASE_URL}im`);
        return this.http.post(`${url}`, im);
    }
}
